// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TvvV","delete":"styles_delete__2vsiL","update":"styles_update__1Tz87","add":"styles_add__3gbAh"};